import { ReactNode } from 'react';
import { ToastNotificationProvider } from '@opswat/ui';
import { LimitPromptProvider } from 'services/LimitPrompt';
import { SWRProvider } from 'services/swr';
import { UserProvider } from 'services/User';
import { ErrorBoundary } from 'components/ErrorBoundary';

interface WrapRootProps {
    children: ReactNode;
}

export const WrapRoot = ({ children }: WrapRootProps) => {
    // ErrorBoundary is the outermost wrapper so render errors thrown by any
    // provider (including the toast provider) are caught too.
    return (
        <ErrorBoundary>
            <ToastNotificationProvider>
                <UserProvider>
                    <SWRProvider>
                        {/* Innermost so the existing provider order stays untouched, and still
                            below UserProvider, which it needs for `useUser`. Mounting it here
                            covers both the authenticated Layout and the guest PublicLayout. */}
                        <LimitPromptProvider>{children}</LimitPromptProvider>
                    </SWRProvider>
                </UserProvider>
            </ToastNotificationProvider>
        </ErrorBoundary>
    );
};
